/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import api from '../../../services/axios'
import Home from '../../../assets/icons/alert.svg'
import valid from '../../../assets/icons/warn.svg'
import itens from '../../../assets/icons/check.svg'
import check from '../../../assets/icons/check-green.svg'
import { ContentHeader } from './styles'
import { useMonthFilter } from '../../../context/FiltersContext/MonthFilter'
import { FaFileCircleCheck } from 'react-icons/fa6'
import { IoCloseCircle } from 'react-icons/io5'
import { IoWarning } from 'react-icons/io5'
import { MdOutlinePendingActions } from 'react-icons/md'
import { MainHeader } from './gestor/styles'

function toLocalDate(dateLike: string | number | Date | null | undefined): Date | null {
  if (dateLike == null) return null

  if (dateLike instanceof Date) {
    return new Date(dateLike.getFullYear(), dateLike.getMonth(), dateLike.getDate())
  }

  if (typeof dateLike === 'number') {
    const dt = new Date(dateLike)
    if (isNaN(dt.getTime())) return null
    return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate())
  }

  const s = String(dateLike).trim()
  if (!s) return null

  // 1. Formato YYYYMMDD ou DDMMAAAA (8 dígitos sem separador)
  const m8 = s.match(/^(\d{4})(\d{2})(\d{2})$/)
  if (m8) {
    const p1 = Number(m8[1])
    const p2 = Number(m8[2])
    const p3 = Number(m8[3])
    if (p1 >= 1900 && p1 <= 2100 && p2 >= 1 && p2 <= 12 && p3 >= 1 && p3 <= 31) {
      return new Date(p1, p2 - 1, p3)
    }
  }

  const m8br = s.match(/^(\d{2})(\d{2})(\d{4})$/)
  if (m8br) {
    const d = Number(m8br[1])
    const mo = Number(m8br[2])
    const y = Number(m8br[3])
    if (y >= 1900 && y <= 2100 && mo >= 1 && mo <= 12 && d >= 1 && d <= 31) {
      return new Date(y, mo - 1, d)
    }
  }

  // 2. Formato YYYY-MM-DD
  const mIso = s.match(/^(\d{4})[-_.](\d{2})[-_.](\d{2})/)
  if (mIso) {
    return new Date(Number(mIso[1]), Number(mIso[2]) - 1, Number(mIso[3]))
  }

  // 3. Formato DD/MM/YYYY
  const mBr = s.match(/^(\d{2})[-/.](\d{2})[-/.](\d{4})/)
  if (mBr) {
    return new Date(Number(mBr[3]), Number(mBr[2]) - 1, Number(mBr[1]))
  }

  const parsed = new Date(s)
  if (isNaN(parsed.getTime())) return null
  return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate())
}

function dateKey(d: Date) {
  return `${d.getFullYear().toString().padStart(4, '0')}-${(d.getMonth() + 1)
    .toString()
    .padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`
}

function HeaderContent() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [files, setFiles] = useState<any[]>([])
  const [estoqueList, setEstoqueList] = useState<any[]>([])
  const [estoqueMesList, setEstoqueMesList] = useState<any[]>([])
  const [distribuidores, setDistribuidores] = useState<{ id: string; name: string }[]>([])
  const [justificativas, setJustificativas] = useState<
    { dist_id: string; dt_referencia: string }[]
  >([])
  const { month: selectedMonth, year: selectedYear } = useMonthFilter()

  // arquivos filtrados pelo mês/ano selecionados
  const filesInSelectedMonth = useMemo(() => {
    return files.filter((f) => {
      const d = toLocalDate(f.envio || f.created_at || f.dt_envio)
      return d && d.getMonth() === selectedMonth && d.getFullYear() === selectedYear
    })
  }, [files, selectedMonth, selectedYear])

  const estoqueInSelectedMonth = useMemo(() => {
    return estoqueList.filter((e) => {
      const d = toLocalDate(e.dt_ref || e.created_at)
      return d && d.getMonth() === selectedMonth && d.getFullYear() === selectedYear
    })
  }, [estoqueList, selectedMonth, selectedYear])

  const estoqueMesInSelectedMonth = useMemo(() => {
    return estoqueMesList.filter((em) => {
      return Number(em.mes) === selectedMonth + 1 && Number(em.ano) === selectedYear
    })
  }, [estoqueMesList, selectedMonth, selectedYear])

  useEffect(() => {
    const fetchEstoque = async () => {
      setLoading(true)
      try {
        const [resFiles, resDist, resEstoque, resEstoqueMes] = await Promise.all([
          api.get('/files').catch(() => ({ data: [] })),
          api.get('/dist').catch(() => ({ data: [] })),
          api.get('/get/estoque').catch(() => ({ data: [] })),
          api.get('/estoque/mensal').catch(() => ({ data: [] })),
        ])

        const allDists = Array.isArray(resDist.data) ? resDist.data : []
        const firstDistId = allDists.length > 0 ? allDists[0].id : null
        const resJust = firstDistId ? await api.get(`/j/dist/${firstDistId}`).catch(() => ({ data: [] })) : { data: [] }

        const filesData = Array.isArray(resFiles.data) ? resFiles.data : []
        const estData = Array.isArray(resEstoque.data) ? resEstoque.data : []
        const estMesData = Array.isArray(resEstoqueMes.data) ? resEstoqueMes.data : []

        setFiles(filesData)
        setEstoqueList(estData)
        setEstoqueMesList(estMesData)

        // Filtra os distribuidores: se status for 0, entra se tiver arquivo ou estoque no mês
        const currentFiles = filesData.filter((f: any) => {
          const d = toLocalDate(f.envio || f.created_at || f.dt_envio)
          return d && d.getMonth() === selectedMonth && d.getFullYear() === selectedYear
        })

        const filteredDists = allDists.filter((item: any) => {
          if (item.status !== '0') return true
          const hasFile = currentFiles.some((fi: any) => String(fi.dist_id) === String(item.id))
          const hasEst = estData.some((e: any) => {
            const d = toLocalDate(e.dt_ref || e.created_at)
            return d && d.getMonth() === selectedMonth && d.getFullYear() === selectedYear && String(e.dist_id) === String(item.id)
          })
          const hasEstMes = estMesData.some((em: any) => Number(em.mes) === selectedMonth + 1 && Number(em.ano) === selectedYear && String(em.dist_id) === String(item.id))
          return hasFile || hasEst || hasEstMes
        })

        setDistribuidores(filteredDists)
        setJustificativas(Array.isArray(resJust.data) ? resJust.data : [])
      } catch (error) {
        console.error(error)
      } finally {
        setLoading(false)
      }
    }
    fetchEstoque()
  }, [navigate, selectedMonth, selectedYear])

  const hoje = new Date()

  // Distribuidores com atraso D-2 (considerando justificativas) — usa arquivos e estoque no banco
  const comAtraso = distribuidores.filter((dist) => {
    const arquivosDist = filesInSelectedMonth.filter((f) => String(f.dist_id) === String(dist.id))
    const estoqueDist = estoqueInSelectedMonth.filter((e) => String(e.dist_id) === String(dist.id))
    const temEstoqueMes = estoqueMesInSelectedMonth.some((em) => String(em.dist_id) === String(dist.id))

    // D-2 relativo a hoje
    const dataD2 = new Date()
    dataD2.setDate(hoje.getDate() - 2)

    // Verifica se tem justificativa para D-2 (mesmo dia, mês e ano)
    const justificativa = justificativas.some((j) => {
      const refDate = toLocalDate(j.dt_referencia)
      return (
        String(j.dist_id) === String(dist.id) &&
        refDate &&
        refDate.getDate() === dataD2.getDate() &&
        refDate.getMonth() === dataD2.getMonth() &&
        refDate.getFullYear() === dataD2.getFullYear()
      )
    })

    // Para estoque, o dia máximo cobre os dias de 1 até maxEstDay
    let maxEstDay = 0
    arquivosDist.forEach((f) => {
      const nm = String(f.nm_file || '').toLowerCase()
      if (nm.includes('estoque') || nm.includes('esto') || nm.startsWith('est')) {
        const d = toLocalDate(f.envio || f.created_at || f.dt_envio)
        if (d && d.getMonth() === selectedMonth && d.getFullYear() === selectedYear && d.getDate() > maxEstDay) {
          maxEstDay = d.getDate()
        }
      }
    })
    estoqueDist.forEach((e) => {
      const d = toLocalDate(e.dt_ref || e.created_at)
      if (d && d.getMonth() === selectedMonth && d.getFullYear() === selectedYear && d.getDate() > maxEstDay) {
        maxEstDay = d.getDate()
      }
    })

    const isCurrentMonth =
      selectedMonth === hoje.getMonth() && selectedYear === hoje.getFullYear()
    const isFutureMonth =
      selectedYear > hoje.getFullYear() ||
      (selectedYear === hoje.getFullYear() && selectedMonth > hoje.getMonth())

    if (isFutureMonth) {
      maxEstDay = 0
    } else if (isCurrentMonth) {
      maxEstDay = Math.min(maxEstDay, hoje.getDate())
    }

    // Verifica se teve algum envio ou estoque cobrindo D-2
    const teveEnvioD2 = (maxEstDay > 0 && maxEstDay >= dataD2.getDate()) || arquivosDist.some((f) => {
      const dataEnvio = toLocalDate(f.envio || f.created_at || f.dt_envio)
      if (!dataEnvio) return false
      return (
        dataEnvio.getDate() === dataD2.getDate() &&
        dataEnvio.getMonth() === dataD2.getMonth() &&
        dataEnvio.getFullYear() === dataD2.getFullYear()
      )
    })

    return !teveEnvioD2 && !justificativa
  }).length

  // Contagem de dias em que houve estoque mas sem sellout, por distribuidor, no mês selecionado
  const semSellout = (() => {
    let count = 0

    distribuidores.forEach((dist) => {
      const arquivosDist = filesInSelectedMonth.filter((f) => String(f.dist_id) === String(dist.id))
      if (!arquivosDist.length) return

      // agrupa nomes por dia
      const filesByDay: Record<string, string[]> = {}
      arquivosDist.forEach((f) => {
        const d = toLocalDate(f.envio || f.created_at || f.dt_envio)
        if (!d) return
        const key = dateKey(d)
        filesByDay[key] = filesByDay[key] || []
        const nm = (f.nm_file || f.originalname || f.filename || '').toString()
        filesByDay[key].push(nm.toLowerCase())
      })

      const hasDaySemSellout = Object.keys(filesByDay).some((dayKey) => {
        const names = filesByDay[dayKey]
        const hasEstoque = names.some((n) => n.includes('estoque'))
        const hasSellout = names.some(
          (n) => n.includes('sellout') || n.includes('venda') || n.includes('vendas'),
        )
        return hasEstoque && !hasSellout
      })

      if (hasDaySemSellout) count++
    })

    return count
  })()

  // Distribuidor atual (primeiro da lista) — arquivos desse distribuidor no mês selecionado
  const distribuidorAtual = distribuidores[0]
  const arquivosDoDistribuidorNoMes = distribuidorAtual
    ? filesInSelectedMonth.filter((f) => String(f.dist_id) === String(distribuidorAtual.id))
    : []

  // Total de arquivos enviados no mês (todos os distribuidores)
  const totalArquivosNoMes = filesInSelectedMonth.length

  // Total de arquivos recebidos para exibir (ajuste para o que preferir)
  const enviados = totalArquivosNoMes
  const recebidos = totalArquivosNoMes

  // Justificativas no mês selecionado para o distribuidor atual
  const justificadosCount = justificativas.filter((j) => {
    const refDate = toLocalDate(j.dt_referencia)
    return (
      refDate &&
      refDate.getMonth() === selectedMonth &&
      refDate.getFullYear() === selectedYear &&
      String(j.dist_id) === String(distribuidorAtual?.id)
    )
  }).length

  const iconsC = [
    {
      id: 0,
      src: <IoCloseCircle />,
      alt: 'Painel Geral',
      label: 'Distribuidores com Atraso',
      dist: `${comAtraso} distribuidores`,
      status: 'warn',
      class: 'warn-label',
    },
    {
      id: 1,
      src: <IoWarning />,
      alt: 'Regularidade',
      label: 'Estoque enviado sem Sellout',
      dist: `${semSellout} distribuidores`,
      status: 'alert',
      class: 'alert-label',
    },
    {
      id: 2,
      src: <MdOutlinePendingActions />,
      alt: 'Produtos',
      label: 'Distribuidores Justificados',
      dist: `${justificadosCount} distribuidores`,
      status: 'check',
      class: 'check-label',
    },
    {
      id: 3,
      src: <FaFileCircleCheck />,
      alt: 'Produtos',
      label: 'Arquivos Recebidos',
      dist: `${recebidos} arquivos`,
      status: 'check-green',
      class: 'check-green-label',
    },
  ]

  return (
    <>
      <MainHeader>
        {iconsC.map((item) => (
          <ContentHeader key={item.id}>
            <div className='content'>
              <label className={item.class}>{item.src}</label>
              <div>
                <label className={item.status}>{item.label}</label>
                <p className={item.status}>{item.dist}</p>
              </div>
            </div>
          </ContentHeader>
        ))}
      </MainHeader>
    </>
  )
}

export default HeaderContent
